import { render } from "./couponLoading.vue?vue&type=template&id=1e998bd9&scoped=true"
import script from "./couponLoading.vue?vue&type=script&lang=js"
export * from "./couponLoading.vue?vue&type=script&lang=js"

import "./couponLoading.vue?vue&type=style&index=0&id=1e998bd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e998bd9"]])

export default __exports__